// src/pages/FarmerDashboard.tsx - VERSION CORRIGÉE avec montants incluant frais de livraison
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import FarmerNegotiationsTab from '../components/FarmerNegotiationsTab';
import productService, { Product } from '../services/productService'; // ✅ IMPORT Product TYPE

import { 
  ShoppingBag, 
  TrendingUp, 
  Package, 
  Users, 
  Bell, 
  CheckCircle, 
  Clock, 
  AlertCircle,
  Phone,
  CreditCard,
  DollarSign,
  Eye,
  X,
  MessageCircle,
  Handshake,
  Truck
} from 'lucide-react';
import orderService, { OrderStats, Order, PaymentConfirmation } from '../services/orderService';
import OrderNotifications from '../components/OrderNotifications';

// ✅ SUPPRIMÉ - Interface Product locale (on utilise celle du productService)

interface FarmerStats {
  totalProducts: number;
  totalSales: number;
  pendingOrders: number;
}

const ProfileTab = ({ user }: { user: any }) => {
  const [phone, setPhone] = useState(user?.phone || '');
  const [merchantPhone, setMerchantPhone] = useState(user?.merchant_phone || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    setError('');
    try {
      const response = await api.put('/farmer/profile', {
        phone: phone || null,
        merchant_phone: merchantPhone || null
      });
      setMessage('Profil mis à jour avec succès !');

      setMessage('Profil mis à jour avec succès !');
      const updatedUser = { ...JSON.parse(localStorage.getItem('user') || '{}'), phone, merchant_phone: merchantPhone };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      setTimeout(() => window.location.reload(), 1500);

    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur lors de la mise à jour.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 max-w-lg">
      <h2 className="text-xl font-semibold text-slate mb-6">Mon profil</h2>
      {message && <div className="bg-green-100 text-green-700 px-4 py-3 rounded mb-4">{message}</div>}
      {error && <div className="bg-red-100 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate mb-1">Nom</label>
          <input type="text" value={user?.name || ''} readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate mb-1">Email</label>
          <input type="text" value={user?.email || 'Non renseigné'} readOnly className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate mb-1">Téléphone *</label>
          <input
            type="tel"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
            placeholder="+22901XXXXXXXX"
          />
          <p className="text-xs text-gray-500 mt-1">Requis pour recevoir les paiements et les notifications Telegram</p>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate mb-1">Numéro marchand Mobile Money</label>
          <input
            type="tel"
            value={merchantPhone}
            onChange={e => setMerchantPhone(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
            placeholder="+22901XXXXXXXX"
          />
          <p className="text-xs text-gray-500 mt-1">Numéro MTN MoMo ou Moov Money pour recevoir les paiements. Si différent de votre téléphone.</p>
        </div>
        <button
          onClick={handleSave}
          disabled={saving}
          className="w-full bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition duration-300 disabled:opacity-50"
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
};



const FarmerDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState<FarmerStats>({
    totalProducts: 0,
    totalSales: 0,
    pendingOrders: 0
  });

  // ✅ NOUVEAU - États pour l'onglet actif
  const [activeTab, setActiveTab] = useState('dashboard');

  // Stats commandes Phase 1
  const [orderStats, setOrderStats] = useState<OrderStats | null>(null);
  const [loadingOrderStats, setLoadingOrderStats] = useState(true);

  // États pour confirmation paiements
  const [pendingPayments, setPendingPayments] = useState<Order[]>([]);
  const [loadingPayments, setLoadingPayments] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [confirmationData, setConfirmationData] = useState<PaymentConfirmation>({
    amount_received: 0,
    payment_method: 'mobile_money',
    payment_reference: '',
    notes: ''
  });
  const [confirmingPayment, setConfirmingPayment] = useState(false);
  
  // ✅ NOUVEAU - État pour les vraies statistiques des produits
  const [useRealProductStats, setUseRealProductStats] = useState(true);

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        const userResponse = await api.get('/auth/me');
        const userData = userResponse.data;
        
        if (!userData.is_farmer) {
          navigate('/');
          return;
        }

        // Charger toutes les données en parallèle
        await Promise.all([
          loadFarmerStats(),
          loadFarmerProducts(),
          loadOrderStats(userData.id),
          loadPendingPayments()
        ]);
      } catch (err) {
        console.error('Erreur lors du chargement des données:', err);
        
        if (err.response && err.response.status === 401) {
          navigate('/login');
        } else {
          setError('Erreur lors du chargement du tableau de bord. Veuillez réessayer.');
        }
      } finally {
        setLoading(false);
      }
    };

    loadDashboard();
  }, [navigate]);

  // ✅ NOUVEAU - Recharger les produits quand le type de stats change
  useEffect(() => {
    if (user?.is_farmer) {
      loadFarmerProducts();
    }
  }, [useRealProductStats, user]);

  const loadFarmerStats = async () => {
    try {
      const statsResponse = await api.get('/farmer/stats');
      setStats(statsResponse.data);
    } catch (error) {
      console.error('Error loading farmer stats:', error);
    }
  };

  const loadFarmerProducts = async () => {
    try {
      console.log('📦 Chargement produits farmer...');
      
      if (useRealProductStats) {
        // ✅ NOUVEAU - Utiliser les vraies statistiques comme MyProductsPage
        try {
          const productsWithStats = await productService.getFarmerProductsWithRealStats();
          setProducts(productsWithStats);
          console.log('✅ Produits farmer chargés avec vraies stats');
        } catch (statsError) {
          console.warn('⚠️ Fallback vers stats statiques pour onglet produits...');
          const productsResponse = await api.get('/farmer/products');
          setProducts(productsResponse.data);
        }
      } else {
        const productsResponse = await api.get('/farmer/products');
        setProducts(productsResponse.data);
        console.log('✅ Produits farmer chargés (stats statiques)');
      }
    } catch (error) {
      console.error('Error loading farmer products:', error);
    }
  };

  const loadOrderStats = async (userId: number) => {
    try {
      setLoadingOrderStats(true);
      const orderStatsData = await orderService.getFarmerOrderStats(userId);
      setOrderStats(orderStatsData);
    } catch (error) {
      console.error('Error loading order stats:', error);
    } finally {
      setLoadingOrderStats(false);
    }
  };

  const loadPendingPayments = async () => {
    try {
      setLoadingPayments(true);
      const pendingData = await orderService.getFarmerPendingPayments(user?.id || 0);
      setPendingPayments(pendingData);
    } catch (error) {
      console.error('Error loading pending payments:', error);
    } finally {
      setLoadingPayments(false);
    }
  };

  const handleConfirmPayment = (order: Order) => {
    setSelectedOrder(order);
    // ✅ CORRECTION: Utiliser order.total_price pour inclure les frais de livraison
    setConfirmationData({
      amount_received: order.total_price, // Utiliser le montant total avec frais de livraison
      payment_method: 'mobile_money',
      payment_reference: '',
      notes: ''
    });
    setShowConfirmModal(true);
  };

  const handleSubmitConfirmation = async () => {
    if (!selectedOrder) return;

    try {
      setConfirmingPayment(true);
      
      await orderService.confirmPaymentReceived(selectedOrder.id, confirmationData);
      
      // Recharger les données
      await Promise.all([
        loadPendingPayments(),
        loadOrderStats(user?.id || 0),
        loadFarmerStats()
      ]);
      
      setShowConfirmModal(false);
      setSelectedOrder(null);
      
      alert(`Paiement confirmé avec succès pour la commande #${selectedOrder.id} !`);
      
    } catch (error) {
      console.error('Error confirming payment:', error);
      alert('Erreur lors de la confirmation du paiement. Veuillez réessayer.');
    } finally {
      setConfirmingPayment(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (!confirm('Êtes-vous sûr de vouloir supprimer ce produit ?')) {
      return;
    }

    try {
      await productService.deleteProduct(id);
      setProducts(products.filter(product => product.id !== id));
      alert(`Produit #${id} supprimé avec succès`);
      
      await loadFarmerStats();
    } catch (err: any) {
      console.error('Erreur lors de la suppression du produit:', err);
      if (err.response?.data?.detail) {
        alert(`Erreur: ${err.response.data.detail}`);
      } else {
        alert('Erreur lors de la suppression du produit');
      }
    }
  };

  // ✅ NOUVELLE FONCTION: Calculer le montant à afficher (avec ou sans frais de livraison)
  const getDisplayAmount = (order: Order): number => {
    // Toujours afficher le montant total que le client paie (avec frais de livraison)
    return order.total_price;
  };

  // ✅ NOUVELLE FONCTION: Obtenir les détails de facturation
  const getBillingDetails = (order: Order): {
    customerTotal: number;
    farmerPart: number;
    deliveryFees: number;
    showBreakdown: boolean;
  } => {
    const customerTotal = order.total_price;
    const farmerPart = order.farmer_total || order.total_price;
    const deliveryFees = customerTotal - farmerPart;
    
    return {
      customerTotal,
      farmerPart,
      deliveryFees,
      showBreakdown: deliveryFees > 0
    };
  };

  // ✅ NOUVELLE MÉTHODE - Obtenir les vraies quantités vendues (comme MyProductsPage)
  const getRealSoldQuantity = (product: Product): number => {
    return productService.getRealSoldQuantity(product);
  };

  // ✅ NOUVELLE MÉTHODE - Vérifier si les vraies stats sont disponibles
  const hasRealStats = (product: Product): boolean => {
    return product.real_sold !== undefined;
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        {/* Alerte numéro de téléphone manquant */}
        {!user?.phone && !user?.merchant_phone && (
          <div className="bg-red-50 border border-red-300 rounded-lg p-4 mb-6 flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h3 className="font-semibold text-red-900">Action requise — Numéro de téléphone manquant</h3>
              <p className="text-sm text-red-800 mt-1">
                Vos clients ne peuvent pas effectuer de paiement car votre numéro de téléphone n'est pas renseigné.
                Veuillez ajouter votre numéro de téléphone ou numéro marchand Mobile Money.
              </p>
              <button
                onClick={() => setActiveTab('profile')}
                className="mt-2 bg-red-600 text-white px-4 py-1 rounded text-sm hover:bg-red-700 transition"
              >
                Compléter mon profil →
              </button>
            </div>
          </div>
        )}
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-olive border-r-transparent"></div>
          <p className="mt-2">Chargement du tableau de bord...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
        <button 
          onClick={() => window.location.reload()}
          className="bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition duration-300"
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header avec notifications */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-slate">Tableau de bord producteur</h1>
        <div className="flex items-center gap-4">
          {user && <OrderNotifications />}
          <div className="text-right">
            <p className="text-sm text-slate">Connecté en tant que</p>
            <p className="font-semibold text-terracotta">{user?.name}</p>
          </div>
        </div>
      </div>

      {/* ✅ NOUVEAU - Navigation par onglets */}
      <div className="flex border-b border-gray-200 mb-8 overflow-x-auto">
        <button
          className={`py-2 px-4 whitespace-nowrap ${activeTab === 'dashboard' ? 'border-b-2 border-olive text-olive' : 'text-gray-500'}`}
          onClick={() => setActiveTab('dashboard')}
        >
          Tableau de bord
        </button>
        <button
          className={`py-2 px-4 whitespace-nowrap ${activeTab === 'products' ? 'border-b-2 border-olive text-olive' : 'text-gray-500'}`}
          onClick={() => setActiveTab('products')}
        >
          Mes produits
        </button>
        <button
          className={`py-2 px-4 whitespace-nowrap flex items-center gap-2 ${activeTab === 'negotiations' ? 'border-b-2 border-olive text-olive' : 'text-gray-500'}`}
          onClick={() => setActiveTab('negotiations')}
        >
          <Handshake className="h-4 w-4" />
          Négociations
        </button>
        
        <button
          className={`py-2 px-4 whitespace-nowrap ${activeTab === 'profile' ? 'border-b-2 border-olive text-olive' : 'text-gray-500'}`}
          onClick={() => setActiveTab('profile')}
        >
          Mon profil
        </button>

      </div>

      {/* Onglet Dashboard */}
      {activeTab === 'dashboard' && (
        <div className="space-y-8">
          {/* Section commandes en attente de paiement - CORRIGÉE */}
          {pendingPayments.length > 0 && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="h-6 w-6 text-yellow-600" />
                <h2 className="text-xl font-semibold text-yellow-900">
                  Commandes en attente de confirmation de paiement
                </h2>
                <span className="bg-yellow-200 text-yellow-800 px-2 py-1 rounded-full text-sm font-medium">
                  {pendingPayments.length}
                </span>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {pendingPayments.map((order) => {
                  // ✅ NOUVEAU: Obtenir les détails de facturation pour chaque commande
                  const billingDetails = getBillingDetails(order);
                  
                  return (
                    <div key={order.id} className="bg-white border border-yellow-200 rounded-lg p-4">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h3 className="font-semibold text-slate">Commande #{order.id}</h3>
                          <p className="text-sm text-gray-600">
                            {orderService.formatDate(order.created_at)}
                          </p>
                        </div>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${orderService.getStatusColor(order.status)}`}>
                          {orderService.getStatusLabel(order.status)}
                        </span>
                      </div>
                      
                      <div className="space-y-2 mb-4">
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Client:</span>
                          <span className="font-medium">{order.customer_name}</span>
                        </div>
                        
                        {/* ✅ CORRECTION PRINCIPALE: Afficher le montant total (avec frais de livraison) */}
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Montant total:</span>
                          <span className="font-bold text-terracotta">
                            {orderService.formatPrice(getDisplayAmount(order))}
                          </span>
                        </div>
                        
                        {/* ✅ NOUVEAU: Affichage détaillé si il y a des frais de livraison */}
                        {billingDetails.showBreakdown && (
                          <div className="text-xs text-gray-500 space-y-1 pl-2 border-l-2 border-gray-200">
                            <div className="flex justify-between">
                              <span>Produits:</span>
                              <span>{orderService.formatPrice(billingDetails.farmerPart)}</span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="flex items-center gap-1">
                                <Truck className="h-3 w-3" />
                                Livraison:
                              </span>
                              <span>{orderService.formatPrice(billingDetails.deliveryFees)}</span>
                            </div>
                          </div>
                        )}
                        
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Téléphone:</span>
                          <span className="font-medium">{order.customer_phone}</span>
                        </div>
                      </div>
                      
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleConfirmPayment(order)}
                          className="flex-1 bg-green-600 text-white px-3 py-2 rounded text-sm hover:bg-green-700 transition duration-300 flex items-center justify-center gap-1"
                        >
                          <CheckCircle className="h-4 w-4" />
                          Confirmer
                        </button>
                        <button
                          onClick={() => {/* TODO: Voir détails */}}
                          className="bg-gray-100 text-gray-700 px-3 py-2 rounded text-sm hover:bg-gray-200 transition duration-300"
                        >
                          <Eye className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/* Stats Commandes Phase 1 */}
          <div>
            <h2 className="text-xl font-semibold text-slate mb-4">Statistiques des commandes</h2>
            {loadingOrderStats ? (
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="bg-white rounded-lg shadow-md p-6 animate-pulse">
                    <div className="h-4 bg-gray-200 rounded mb-2"></div>
                    <div className="h-8 bg-gray-200 rounded"></div>
                  </div>
                ))}
              </div>
            ) : orderStats ? (
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-slate font-medium mb-2">Total des ventes</h3>
                      <p className="text-3xl font-bold text-terracotta">
                        {orderService.formatPrice(orderStats.total_sales)}
                      </p>
                    </div>
                    <TrendingUp className="h-8 w-8 text-olive" />
                  </div>
                </div>
                
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-slate font-medium mb-2">Commandes totales</h3>
                      <p className="text-3xl font-bold text-terracotta">{orderStats.total_orders}</p>
                    </div>
                    <ShoppingBag className="h-8 w-8 text-olive" />
                  </div>
                </div>
                
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-slate font-medium mb-2">Paiements en attente</h3>
                      <p className="text-3xl font-bold text-yellow-600">
                        {orderStats.pending_payments || 0}
                      </p>
                    </div>
                    <Clock className="h-8 w-8 text-yellow-500" />
                  </div>
                </div>
                
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-slate font-medium mb-2">Cette semaine</h3>
                      <p className="text-3xl font-bold text-terracotta">{orderStats.recent_orders}</p>
                    </div>
                    <Users className="h-8 w-8 text-purple-600" />
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-lg shadow-md p-6 text-center">
                <ShoppingBag className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                <p className="text-slate">Aucune donnée de commande disponible</p>
              </div>
            )}
          </div>

          {/* Actions rapides */}
          <div>
            <h2 className="text-xl font-semibold text-slate mb-4">Actions rapides</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <a 
                href="/farmer/orders"
                className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow text-left block"
              >
                <ShoppingBag className="h-8 w-8 text-olive mb-2" />
                <h3 className="font-semibold text-slate">Gérer les commandes</h3>
                <p className="text-sm text-gray-600">Voir et traiter les commandes reçues</p>
              </a>
              
              <button
                onClick={() => setActiveTab('products')}
                className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow text-left block"
              >
                <Package className="h-8 w-8 text-olive mb-2" />
                <h3 className="font-semibold text-slate">Mes produits</h3>
                <p className="text-sm text-gray-600">Gérer votre catalogue de produits</p>
              </button>
              
              <a 
                href="/add-product"
                className="p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow text-left block"
              >
                <TrendingUp className="h-8 w-8 text-olive mb-2" />
                <h3 className="font-semibold text-slate">Ajouter un produit</h3>
                <p className="text-sm text-gray-600">Créer un nouveau produit à vendre</p>
              </a>
            </div>
          </div>
          
          {/* Stats Cards existantes avec vraies statistiques */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-slate font-medium mb-2">Produits publiés</h3>
              <p className="text-3xl font-bold text-terracotta">{stats.totalProducts}</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-slate font-medium mb-2">Produits vendus</h3>
                  {/* ✅ CORRECTION - Utiliser les vraies statistiques */}
                  <p className="text-3xl font-bold text-terracotta">
                    {products.reduce((sum, p) => sum + getRealSoldQuantity(p), 0)}
                  </p>
                </div>
                {/* ✅ NOUVEAU - Indicateur de type de stats */}
                {useRealProductStats && products.some(hasRealStats) && (
                  <CheckCircle className="h-6 w-6 text-green-500" title="Statistiques en temps réel" />
                )}
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-slate font-medium mb-2">Commandes en attente</h3>
              <p className="text-3xl font-bold text-terracotta">{stats.pendingOrders}</p>
            </div>
          </div>
        </div>
      )}

      {/* Onglet Produits - CORRIGÉ avec vraies statistiques */}
      {activeTab === 'products' && (
        <div>
          {/* Add Product Button */}
          <div className="mb-6 flex justify-between items-center">
            <div>
              <h2 className="text-xl font-semibold text-slate">Mes produits</h2>
              {/* ✅ NOUVEAU - Indicateur de type de statistiques */}
              {products.length > 0 && (
                <div className="flex items-center mt-2 text-sm">
                  {useRealProductStats && products.some(hasRealStats) ? (
                    <div className="flex items-center text-green-600">
                      <CheckCircle className="h-4 w-4 mr-1" />
                      Statistiques en temps réel
                    </div>
                  ) : (
                    <div className="flex items-center text-yellow-600">
                      <AlertCircle className="h-4 w-4 mr-1" />
                      Statistiques en cache
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="flex space-x-3">
              {/* ✅ NOUVEAU - Bouton rafraîchir stats */}
              <button
                onClick={loadFarmerProducts}
                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition flex items-center"
                title="Rafraîchir les statistiques"
              >
                <CheckCircle className="w-4 h-4 mr-2" />
                Actualiser
              </button>
              <Link 
                to="/add-product" 
                className="bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition duration-300 inline-flex items-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                Ajouter un produit
              </Link>
            </div>
          </div>
          
          {/* Products Table avec vraies statistiques */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            {products.length === 0 ? (
              <div className="p-6 text-center">
                <p>Vous n'avez pas encore de produits. Commencez par en ajouter un!</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Produit
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Prix
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Stock
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {/* ✅ NOUVEAU - En-tête avec indicateur */}
                        <div className="flex items-center space-x-1">
                          <span>Vendus</span>
                          {useRealProductStats && products.some(hasRealStats) && (
                            <CheckCircle className="h-3 w-3 text-green-500" title="Temps réel" />
                          )}
                        </div>
                      </th>
                      <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {products.map((product) => {
                      // ✅ CORRECTION PRINCIPALE - Utiliser les vraies statistiques
                      const realSold = getRealSoldQuantity(product);
                      const isRealTime = hasRealStats(product);
                      
                      return (
                        <tr key={product.id}>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img 
                                  className="h-10 w-10 rounded-full object-cover" 
                                  src={productService.getImageUrl(product.image_url)} 
                                  alt={product.name}
                                  onError={(e) => {
                                    e.currentTarget.src = '/placeholder-image.jpg';
                                  }}
                                />
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-gray-900">{product.name}</div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{productService.formatPrice(product.price)}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{product.stock} unités</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {/* ✅ CORRECTION PRINCIPALE - Vraies statistiques au lieu de product.sold */}
                            <div className="flex items-center space-x-1">
                              <span className="text-sm text-gray-900">{realSold} unités</span>
                              {isRealTime && useRealProductStats && (
                                <CheckCircle className="h-3 w-3 text-green-500" title="Données en temps réel" />
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                            <Link 
                              to={`/edit-product/${product.id}`} 
                              className="text-olive hover:text-terracotta mr-4"
                            >
                              Modifier
                            </Link>
                            <button 
                              onClick={() => handleDelete(product.id)} 
                              className="text-red-600 hover:text-red-900"
                            >
                              Supprimer
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ✅ NOUVEAU - Onglet Négociations */}
      {activeTab === 'negotiations' && (
        <FarmerNegotiationsTab />
      )}

      {/* Onglet Mon profil */}
      {activeTab === 'profile' && (
        <ProfileTab user={user} />
      )}

      {/* Modal de confirmation de paiement - CORRIGÉE */}
      {showConfirmModal && selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-slate">
                  Confirmer le paiement
                </h3>
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium text-slate mb-2">Commande #{selectedOrder.id}</h4>
                <div className="space-y-1 text-sm text-gray-600">
                  <p><span className="font-medium">Client:</span> {selectedOrder.customer_name}</p>
                  <p><span className="font-medium">Téléphone:</span> {selectedOrder.customer_phone}</p>
                  {/* ✅ CORRECTION: Afficher le montant total dans le modal aussi */}
                  <p><span className="font-medium">Montant total:</span> {orderService.formatPrice(selectedOrder.total_price)}</p>
                  
                  {/* ✅ NOUVEAU: Afficher la répartition si applicable */}
                  {(() => {
                    const billing = getBillingDetails(selectedOrder);
                    return billing.showBreakdown ? (
                      <div className="mt-2 pt-2 border-t border-gray-200 text-xs space-y-1">
                        <div className="flex justify-between">
                          <span>Produits:</span>
                          <span>{orderService.formatPrice(billing.farmerPart)}</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Frais de livraison:</span>
                          <span>{orderService.formatPrice(billing.deliveryFees)}</span>
                        </div>
                      </div>
                    ) : null;
                  })()}
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate mb-2">
                    Montant reçu *
                  </label>
                  <input
                    type="number"
                    value={confirmationData.amount_received}
                    onChange={(e) => setConfirmationData(prev => ({
                      ...prev,
                      amount_received: parseFloat(e.target.value) || 0
                    }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
                    placeholder="Montant en FCFA"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate mb-2">
                    Mode de paiement
                  </label>
                  <select
                    value={confirmationData.payment_method}
                    onChange={(e) => setConfirmationData(prev => ({
                      ...prev,
                      payment_method: e.target.value
                    }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
                  >
                    <option value="mobile_money">Mobile Money</option>
                    <option value="cash">Espèces</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate mb-2">
                    Référence de transaction
                  </label>
                  <input
                    type="text"
                    value={confirmationData.payment_reference}
                    onChange={(e) => setConfirmationData(prev => ({
                      ...prev,
                      payment_reference: e.target.value
                    }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
                    placeholder="Référence MTN MoMo ou autre"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate mb-2">
                    Notes (optionnel)
                  </label>
                  <textarea
                    value={confirmationData.notes}
                    onChange={(e) => setConfirmationData(prev => ({
                      ...prev,
                      notes: e.target.value
                    }))}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-olive"
                    placeholder="Commentaires sur le paiement..."
                  />
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  disabled={confirmingPayment}
                  className="flex-1 bg-gray-200 text-slate px-4 py-2 rounded-md hover:bg-gray-300 transition duration-300 disabled:opacity-50"
                >
                  Annuler
                </button>
                <button
                  onClick={handleSubmitConfirmation}
                  disabled={confirmingPayment || confirmationData.amount_received <= 0}
                  className="flex-1 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300 disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {confirmingPayment ? (
                    <>
                      <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                      Confirmation...
                    </>
                  ) : (
                    <>
                      <CheckCircle className="h-4 w-4" />
                      Confirmer le paiement
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FarmerDashboard;